import PropTypes from 'prop-types'

// internal
import { ClusterForm } from '@aytm/app/stats/page/question-views/hm/components/controls/cluster-form/ClusterForm'
import { RecognitionForm } from '@aytm/app/stats/page/question-views/hm/components/controls/recognition-form/RecognitionForm'
import { ControlsPanel } from '@aytm/app/stats/page/question-views/hm/components/controls/controls-panel/ControlsPanel'
import { CLUSTER_FORM_MODE } from '@aytm/app/stats/page/question-views/hm/components/controls/lib/constants'
import { isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'
import { isUserViewerOrGuest } from '@aytm/app/stats/page/question-views/hm/lib/utils'

// styles
import style from '@aytm/app/stats/page/question-views/hm/components/controls/styles/Controls.module.scss'
import { NO_PRINT } from '@aytm/app/stats/page/question-views/components/lib/constants'

const Controls = ({
  id,
  components,
  userRoles,
  clusters,
  config,
  batches,
  visualPosition,
  onFetchCRUDKey,
  onUpdateData,
  image,
  form,
  tip,
  getLassoData,
  currentCluster,
  changeClustersForm,
  onChangeModel
}) => {
  const panel = (
    <ControlsPanel
      id={id}
      form={form}
      userRoles={userRoles}
      batches={batches}
      config={config}
      clusters={clusters}
      onChangeModel={onChangeModel}
      changeClustersForm={changeClustersForm}
    />
  )

  // A form takes the controls' place without changing the band's height, as master's did: the panel
  // stays laid out, hidden, in the same cell, so the band keeps at least its height and the image
  // below does not move when a form opens or closes. The form itself mounts only while it is open --
  // it fetches a key and arms the lasso on mount.
  // One tree in both states, so opening a form does not remount the panel.
  const inPlaceOfPanel = (formElement = null) => (
    <div className={`${style.stack} ${NO_PRINT}`}>
      <div className={formElement ? style.held : style.panel} aria-hidden={formElement ? 'true' : undefined}>
        {panel}
      </div>
      {formElement ? <div className={style.form}>{formElement}</div> : null}
    </div>
  )

  if (
    form.clustersForm.mode === CLUSTER_FORM_MODE.RECOGNITION &&
    !isUserViewerOrGuest(userRoles) &&
    isComponentOn(components, 'recognition')
  ) {
    return inPlaceOfPanel(
      <RecognitionForm
        form={form}
        clusters={clusters}
        visualPosition={visualPosition}
        image={image}
        changeClustersForm={changeClustersForm}
        onFetchCRUDKey={onFetchCRUDKey}
        onUpdateData={onUpdateData}
        onChangeModel={onChangeModel}
      />
    )
  }

  if (form.clustersForm.mode !== CLUSTER_FORM_MODE.OFF && !isUserViewerOrGuest(userRoles)) {
    return inPlaceOfPanel(
      <ClusterForm
        clusters={clusters}
        visualPosition={visualPosition}
        clusterFormMode={form.clustersForm.mode}
        tip={tip}
        currentCluster={currentCluster}
        getLassoData={getLassoData}
        changeClustersForm={changeClustersForm}
        onFetchCRUDKey={onFetchCRUDKey}
        // TODO check if really needed updateData
        // app/_stock/coffeescripts/app/stats/question_views/heatmap/block.coffee
        onUpdateData={() => {}}
        onChangeModel={onChangeModel}
      />
    )
  }

  return inPlaceOfPanel()
}

Controls.displayName = 'HeatmapControls'

Controls.propTypes = {
  id: PropTypes.string,
  userRoles: PropTypes.array,
  components: PropTypes.object,
  clusters: PropTypes.array,
  config: PropTypes.object,
  batches: PropTypes.array,
  visualPosition: PropTypes.number,
  onFetchCRUDKey: PropTypes.func,
  onUpdateData: PropTypes.func,
  image: PropTypes.object,
  form: PropTypes.object.isRequired,
  tip: PropTypes.number,
  getLassoData: PropTypes.func,
  currentCluster: PropTypes.object,
  changeClustersForm: PropTypes.func.isRequired,
  onChangeModel: PropTypes.func
}

export default Controls
